import { ImmutableInstitution } from '../../../CustomPropTypes/InstitutionTypes';

interface InstitutionMenuItem {
  label: string;
  value: string;
}

export const convertInstitutionToMenuOption = (
  institution: ImmutableInstitution
): InstitutionMenuItem => {
  const instJson = institution.toJS();

  return {
    label: instJson.name,
    value: instJson.path,
  };
};

export const institutionFilterPredicate = (compare: string) => (
  institution: InstitutionMenuItem
): boolean => {
  return institution.label.toLowerCase().includes(compare.toLowerCase());
};

export const institutionSortPredicate = (
  a: InstitutionMenuItem,
  b: InstitutionMenuItem
): number => {
  const valueA = a.label;
  const valueB = b.label;

  if (valueA < valueB) {
    return -1;
  } else if (valueA > valueB) {
    return 1;
  } else {
    return 0;
  }
};
